import React from "react";

import Traductor from "../../Traductor";

const ManagementHeader = ({ amount }) => {
  const t = new Traductor();
  return (
    <div className="o-layout">
      <div className="o-layout__item u-1/1 u-mb" key={2}>
        <h1 className="u-mb">{t.getTraduction("MyBatches")}</h1>
        <h3 className="u-mb" style={{ fontWeight: "normal" }}>
          {t.getTraduction("MyBatchesAmount")(amount)}
        </h3>
      </div>
    </div>
  );
};

export default ManagementHeader;
